<div class="container_principal poppins-font">

  <!-- Pantalla Inicial -->
<div class="container_inicial" [class.fade-in]="!cotizacionVisible" [class.fade-out]="cotizacionVisible"  [ngClass]="{ 'visible': step === 0 }">
    <!-- contenido... -->
    <div class="left_logo">
      <img class="logo" src="assets/img/redActiva/logo_redActiva.webp">
      <img class="teamRed" src="assets/img/redActiva/team_webActiva.webp"> 
    </div>
    <div class="right_info">
      <div class="info_content">
        <h3>Más ciudades,</h3>
        <h4>más oportunidades para ti.</h4>
        <p>Envía paquetes más lejos, más rápido y sin preocuparte por la distancia.
          <br><br>
          TUFESAPACK Red Activa te lleva más lejos.
          <br><br>
          ¡Haz la prueba! Realiza tu cotización aquí
        </p>
        <div class="cont_btn">
          <button class="btn_iniciarC" (click)="mostrarCotizacion()">Realizar cotización</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pantalla Cotización -->
<div class="container_cotización" [class.fade-in]="cotizacionVisible" [class.fade-out]="!cotizacionVisible">
    <!-- contenido... -->
    <div class="content-frm">
      <form [formGroup]="cotizadorForm" class="frm-cotizar">
        <h2 *ngIf="step === 1">Conoce el costo de tu envío</h2>
        <h2 *ngIf="step === 2">Cotización lista</h2>
        <h2 *ngIf="step === 3">¿Listo para enviar?</h2>
        <!-- Indicadores de pasos -->
        <div class="steps-indicator">
          <div [class.active]="step === 1">1</div>
          <div class="divider"></div>
          <div [class.active]="step === 2">2</div>
          <div class="divider"></div>
          <div [class.active]="step === 3">3</div>
        </div>

        <!-- Paso 1 -->
        <div [ngClass]="{ 'step': true, 'visible': step === 1 }">
           
          <div class="input-line">
            <i class="fas fa-map-marker-alt"></i>
            <select formControlName="origen" [ngClass]="{'error': cotizadorForm.get('origen')?.invalid && submitted}">
              <option value="" disabled selected>Origen</option>
              <option *ngFor="let ciudad of ciudades" [value]="ciudad.clave">
                {{ ciudad.sucursal }}
              </option>
            </select>
        </div>

        <div class="input-line">
            <i class="fas fa-map-marker-alt"></i>
            <select formControlName="destino" [disabled]="!destinos.length" [ngClass]="{'error': cotizadorForm.get('destino')?.invalid && submitted}">
              <option value="" disabled selected>Destino</option>
              <option *ngFor="let destino of destinos" [value]="destino.sucursal">
                {{ destino.sucursal }}
              </option>
            </select>
        </div>

          <div class="input-line">
            <!-- <i class="fas fa-box"></i> -->
             <!-- <i class="fas fa-box-open"></i> -->
             <!-- <select formControlName="tipoEnvio" [ngClass]="{'error': cotizadorForm.get('tipoEnvio')?.invalid && submitted}">
            <option value="" disabled selected>Selecciona tipo de envío</option>
            <option *ngFor="let tipo of tiposEnvio" [value]="tipo.value">
              {{ tipo.label }}
            </option>
          </select> -->
          <div class="cont_medidas">
            <div>
              <i class="fas fa-ruler-horizontal"></i>
              <input class="medida" type="number" placeholder="Largo cm" formControlName="largo"  [ngClass]="{ 'error': cotizadorForm.get('largo')?.invalid && submitted }"/>
            </div>
            <div>
              <i class="fas fa-ruler-vertical"></i>
              <input class="medida" type="number" placeholder="Alto cm" formControlName="alto"  [ngClass]="{ 'error': cotizadorForm.get('alto')?.invalid && submitted }"/>
            </div>
            <div>
              <i class="fas fa-ruler"></i>
              <input class="medida" type="number" placeholder="Ancho cm" formControlName="ancho"  [ngClass]="{ 'error': cotizadorForm.get('ancho')?.invalid && submitted }"/>
            </div>
          </div>
            <!-- <input type="text" placeholder="Tipo de envío (kg)" formControlName="tipoEnvio"/> -->
          </div>
          <div class="input-line">
            <i class="fas fa-balance-scale"></i>
             <input type="number" placeholder="Peso (máximo 20 kg)" formControlName="peso"  [ngClass]="{ 'error': cotizadorForm.get('peso')?.invalid && submitted }"/>
          </div>
          
             <div class="input-line">
              <i class="fas fa-user"></i>
              <input type="text" placeholder="Nombre Completo" formControlName="nombre"  [ngClass]="{ 'error': cotizadorForm.get('nombre')?.invalid && submitted }"/>
             </div>
            <div class="input-line">
              <i class="fas fa-envelope"></i>
          <input type="email" placeholder="Correo" formControlName="correo"  [ngClass]="{ 'error': cotizadorForm.get('correo')?.invalid && submitted }" />
            </div>
            <div class="input-line">
            <i class="fas fa-phone-volume"></i>
          <input type="tel" pattern="[0-9]*" maxlength="10" placeholder="Tel/Celular" formControlName="celular" [ngClass]="{ 'error': cotizadorForm.get('celular')?.invalid && submitted }"/>
            </div>

              <div *ngIf="mensajeError" class="mensaje-error">
            {{ mensajeError }}
          </div>
        </div>

        <!-- Paso 2 -->
        <!-- <div [ngClass]="{ 'step': true, 'visible': step === 2 }" class="content-step2">
          <p class="p_step">Los tiempos de entrega que se indican son estimados y pueden variar; considérelos solo como referencia, ya que imprevistos operativos o externos podrían adelantar o retrasar la fecha final.</p>
          <div class="info_recorrido">
            <div class="suc_origen">
              <img src="assets/img/redActiva/fast_delivery.png">
              <br>
              <span>Tijuana</span>
            </div>
            <div class="cont_flecha">
              <img appVisibility class="animated_car slideInLeft" src="assets/img/redActiva/animated_car.png">
              <img id="flecha_recorrido" src="assets/img/redActiva/flecha.png">
            </div>
            <div class="suc_destino">
              <img src="assets/img/redActiva/package_end.png">
              <br>
              <span>Puebla</span>
            </div>
          </div>

          <div class="info_entrega">
            <div class="time_status">
             <img src="assets/img/redActiva/time_clock.png">
             <h4>3 dias</h4>
            </div>
            <div class="cont_txt">
              <p class="p_step">Tiempo estimado de entrega: aproximadamente <b>3 días naturales,</b> contados desde la recolección.</p>
            </div>
          </div>
         
        </div> -->

        <!-- Paso 2 -->
        <div [ngClass]="{ 'step': true, 'visible': step === 2 }">
          <p class="p_step">El costo mostrado es un estimado y debe tomarse como referencia. El importe final puede variar debido a factores externos como peso exacto, dimensiones o condiciones específicas del servicio. ¡Gracias por cotizar con TUFESAPACK!​</p>
           <div class="info_recorrido">
            <div class="suc_origen">
              <img src="assets/img/redActiva/fast_delivery.png">
              <br>
              <!-- <span>Tijuana</span> -->
                 <span>{{ origenSeleccionado || 'Origen' }}</span>
            </div>
            <div class="cont_flecha">
              <img appVisibility class="animated_car slideInLeft" src="assets/img/redActiva/animated_car.png">
              <img id="flecha_recorrido" src="assets/img/redActiva/flecha.png">
            </div>
            <div class="suc_destino">
              <img src="assets/img/redActiva/package_end.png">
              <br>
               <span>{{ destinoSeleccionado || 'Destino' }}</span>
            </div>
          </div>
          <div class="content_costo">
             <div class="time_status" style="width: 80%;">
             <img src="assets/img/redActiva/ahorrar-dinero.png">
             <h4 *ngIf="precioCotizacion">${{precioCotizacion}} MXN</h4>
             <p class="p_step" style="text-align: center;">Precio sujeto a cambios según peso y medidas</p>
            </div>
             <img class="personaje" src="assets/img/redActiva/personaje2.webp">
          </div>
        </div>

          <div [ngClass]="{ 'step': true, 'visible': step === 3 }">

          <div class="content_finalstep">
            <div class="txt_finalStep">
              <h4>¡Dale salida a tu envío hoy mismo!</h4>
              <p>Nuestro equipo está listo para recibirte y apoyarte en el proceso.</p>
              <br>
              <h5>Nuestra dirección en tu ciudad es:</h5>
              <h6 *ngIf="direccionSucursal">
                <span>{{ direccionSucursal.nombre }}</span><br>
                <span>{{ direccionSucursal.direccion }}</span><br>
                <span>{{ direccionSucursal.horario }}</span><br>
                <span>{{ direccionSucursal.tel }}</span>
              </h6>
                <!-- Av. Insurgentes #16779 entre Blvd Matamoros e Insurgentes, Col. Zona Rio tercera etapa C.P. 22110-->
               
            </div>
             <img src="assets/img/redActiva/personaje.webp">
          </div>
        </div>

        
        <!-- Botones -->
        <div class="btn-group">
          <button class="btn_prev" type="button" (click)="prevStep()" *ngIf="step > 1 && step <= 3">Regresar</button>
          <button class="align-right" type="button" (click)="solicitarCotizacion()" *ngIf="step === 1">Solicitar Cotización</button>
          <button type="button" (click)="nextStep()" *ngIf="step > 1 && step < 3">Continuar</button>
          <button type="button" (click)="realizarOtraCotizacion()" *ngIf="step === 3">Realizar otra cotización</button>
        </div>
      </form>
    </div>

      <div class="info_content cotizadori" *ngIf="step === 1">
      <img class="logo" src="assets/img/redActiva/logo_redActiva.webp">
      <h4>¿Necesitas llegar a más clientes?</h4>
      <p>
        Con <b>TUFESAPACK Red Activa,</b> ahora conectas con más ciudades que nunca. Llega más lejos con un solo envío:​
        <br><br>
          <b>NORTE:</b> Los Cabos, La Paz, Monterrey, Chihuahua, Ciudad Juárez, Torreón.
          <br><b>CENTRO:</b> CDMX, Puebla, León y Puerto Vallarta.​
          <br><b>SUR:</b> Oaxaca, Huatulco, Villahermosa, Tuxtla, Tapachula, Mérida, Cozumel y Cancún.
      </p>
      <p style="text-align: center;">¡Haz la prueba!</p>
    </div>
     <div class="info_content cotizadori" *ngIf="step === 2">
      <img class="logo" src="assets/img/redActiva/logo_redActiva.webp">
        <h4>Más ciudades, más oportunidades para ti.</h4>
    </div>
      <!-- <div class="info_content cotizadori" *ngIf="step === 2">
      <img class="logo" src="assets/img/redActiva/logo_redActiva.webp">
      <h4>¿Tienes clientes en otras ciudades? 2</h4>
      <p>Con Red Activa puedes llegar más lejos sin complicarte: rápido, accesible y sin importar si hay sucursal
        directa.</p>
      <p>Haz envíos <b>más rápidos,</b> más lejos y con <b>mayor cobertura</b></p>
    </div> -->
    <!-- <div class="info_content cotizadori" *ngIf="step === 3">
      <img class="logo" src="assets/img/redActiva/logo_redActiva.webp">
      <h4>¿Tienes clientes en otras ciudades? 3</h4>
      <p>Con Red Activa puedes llegar más lejos sin complicarte: rápido, accesible y sin importar si hay sucursal
        directa.</p>
      <p>Haz envíos <b>más rápidos,</b> más lejos y con <b>mayor cobertura</b></p>
    </div> -->
     <div class="info_content cotizadori" *ngIf="step === 3">
      <img class="logo" src="assets/img/redActiva/logo_redActiva.webp">
        <h4>Más ciudades, más oportunidades para ti.</h4>
    </div>
  </div>
</div>